function isFunction(possibleFunction) {
    return typeof possibleFunction === "function";
}
function isDireflowComponent(customElementConstructor) {
    var _a;
    return isFunction((_a = customElementConstructor.prototype) === null || _a === void 0 ? void 0 : _a.mountReactApp);
}
function isLitElement(customElementConstructor) {
    const prototype = customElementConstructor.prototype;
    return prototype && isFunction(prototype.update) && isFunction(prototype.render) && isFunction(prototype.updated);
}
function isCustomHtmlElement(customElementConstructor) {
    var _a;
    return (!isLitElement(customElementConstructor) && isFunction((_a = customElementConstructor.prototype) === null || _a === void 0 ? void 0 : _a.attributeChangedCallback));
}
function isReactClassComponent(customElementConstructor) {
    var _a;
    return (_a = customElementConstructor.prototype) === null || _a === void 0 ? void 0 : _a.isReactComponent;
}
function isReactWebComponent(customElementConstructor) {
    var _a;
    return isFunction((_a = customElementConstructor.prototype) === null || _a === void 0 ? void 0 : _a.mountReactComponent);
}
export var ComponentType;
(function (ComponentType) {
    ComponentType[ComponentType["Unknown"] = 0] = "Unknown";
    ComponentType[ComponentType["LitElement"] = 1] = "LitElement";
    ComponentType[ComponentType["ReactClassComponent"] = 2] = "ReactClassComponent";
    ComponentType[ComponentType["ReactWebComponent"] = 3] = "ReactWebComponent";
    ComponentType[ComponentType["CustomHtmlElement"] = 4] = "CustomHtmlElement";
    ComponentType[ComponentType["DireflowComponent"] = 5] = "DireflowComponent";
})(ComponentType || (ComponentType = {}));
export function fromConstructor(customElementConstructor) {
    if (isLitElement(customElementConstructor)) {
        return ComponentType.LitElement;
    }
    if (isReactWebComponent(customElementConstructor)) {
        return ComponentType.ReactWebComponent;
    }
    if (isDireflowComponent(customElementConstructor)) {
        return ComponentType.DireflowComponent;
    }
    if (isCustomHtmlElement(customElementConstructor)) {
        return ComponentType.CustomHtmlElement;
    }
    if (isReactClassComponent(customElementConstructor)) {
        return ComponentType.ReactClassComponent;
    }
    return ComponentType.Unknown;
}
